export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/platform-feature-learn@2x.e1859654198184b5dbb02d8802d72970.png";